export class NetUtil {
    public static getCurrentHost(): string {
        if (window.location && window.location.hostname) {
            return window.location.hostname
        }

        return null
    }

    public static isLocalhost(...localhostAliases: string[]): boolean {
        return NetUtil.isHostAllowed([...localhostAliases, 'localhost'])
    }

    public static isHostAllowed(allowedHosts: string[]): boolean {
        let currentHost: string = NetUtil.getCurrentHost()
        if (currentHost) {
            return allowedHosts.some((host: string) => {
                return currentHost.includes(host)
            })
        }

        return false
    }

    public static inIFrame(): boolean {
        try {
            return window.self !== window.top
        } catch (e) {
            return true
        }
    }

    public static getParam(name: string): string | null {
        let normalizedName = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]')
        let regex = new RegExp('[\\?&]' + normalizedName + '=([^&#]*)')
        let results = regex.exec(location.search)

        return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }

    public static getParamInt(name: string, _default: number = 0): number {
        let value: string = this.getParam(name)
        if (value) {
            let num: number = parseInt(value)
            return isNaN(num) ? _default : num
        }

        return _default
    }

    public static getParamFloat(name: string, _default: number = 0): number {
        let value: string = this.getParam(name)
        if (value) {
            let num: number = parseFloat(value)
            return isNaN(num) ? _default : num
        }

        return _default
    }

    public static getParamBool(name: string, expectedValue: string = '1'): boolean {
        let value: string = NetUtil.getParam(name)

        return !!(value && value === expectedValue)
    }
}
